import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "./../../Contextapi/ContextApi";
import { baseUrl } from "./../../Apiurls/Apiurls";
import Navbar from "../../Shared/Navbar";

const Dashboard = () => {
  const { userId, userRole } = useContext(AuthContext);

  const [totalCount, setTotalCount] = useState(0);
  const [todayCount, setTodayCount] = useState(0);
  const [employeeStats, setEmployeeStats] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]   // DEFAULT TODAY
  );
  const [dateCount, setDateCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const fetchDashboardData = async () => {
    try {
      setIsLoading(true);
      let totalRes, todayRes;

      if (userRole === "Admin") {
        [totalRes, todayRes] = await Promise.all([
          axios.get(`${baseUrl}/api/counts`),
          axios.get(`${baseUrl}/api/todays`),
        ]);

        setTotalCount(totalRes.data.total || 0);
        setTodayCount(todayRes.data.todayCount || 0);

        // Fetch employee stats and date count with selected date
        await Promise.all([
          fetchEmployeeStats(selectedDate),
          fetchDateCount(selectedDate),
        ]);
      } else {
        [totalRes, todayRes] = await Promise.all([
          axios.get(`${baseUrl}/api/applications/count/${userId}`),
          axios.get(`${baseUrl}/api/applications/today/${userId}`),
        ]);

        setTotalCount(totalRes.data.total || 0);
        setTodayCount(todayRes.data.todayCount || 0);
      }
    } catch (error) {
      console.error("Dashboard fetch error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchEmployeeStats = async (date) => {
    try {
      const res = await axios.get(`${baseUrl}/api/admin/employee-stats?date=${date}`);
      setEmployeeStats(res.data);
    } catch (error) {
      console.error("Error fetching employee stats:", error);
    }
  };

  const fetchDateCount = async (date) => {
    if (!date) return;
    try {
      const res = await axios.get(`${baseUrl}/api/admin/date-count?date=${date}`);
      setDateCount(res.data.dateCount || 0);
    } catch (error) {
      console.error("Error fetching date count:", error);
    }
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    fetchEmployeeStats(date);
    fetchDateCount(date);
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-2">
          <Navbar />
        </div>

        <div className="col-md-10">
          <div className="container" style={{ marginTop: "100px" }}>
            {isLoading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                <h2>Dashboard</h2>

                <div className="row mt-4">
                  {/* Total Count */}
                  <div className="col-md-3">
                    <div className="card shadow p-3">
                      <h4>Total Applications</h4>
                      <h2>{totalCount}</h2>
                    </div>
                  </div>

                  {/* Today Count */}
                  <div className="col-md-3">
                    <div className="card shadow p-3">
                      <h4>Today's Submissions</h4>
                      <h2>{todayCount}</h2>
                    </div>
                  </div>

                  
                 
                </div>

                {/* EMPLOYEE CARDS SECTION */}
                {userRole === "Admin" && (
                  <div className="row mt-5">
                    {/* Filter Section - Side by side with employee cards */}
                    {/* Employee Cards Section */}
                    <div className="col-md-12">
                      <div className="card shadow p-3 text-center h-100">
                        <div className="card-body">
                          <div className="d-flex mb-3">
                            <div className="col-md-3">
                              <h3>Employee Submissions</h3>
                            </div>
                            <div className="col-md-3 ml-5">
                              <input
                                type="date"
                                className="form-control "
                                value={selectedDate}
                                onChange={(e) => handleDateChange(e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="row">
                            {employeeStats.length > 0 ? (
                              employeeStats.map((emp, index) => (
                                <div className="col-md-4 mb-3" key={index}>
                                  <div className="card shadow p-3 text-center h-100">
                                    <div className="card-body">
                                      <h5 className="card-title text-primary">{emp.name}</h5>
                                      <div className="mt-3">
                                        <p className="mb-2">
                                          <strong>Total Applications:</strong>
                                          <span className="badge bg-primary ms-2">{emp.total}</span>
                                        </p>
                                        <p className="mb-2">
                                          <strong>Selected Date:</strong>
                                          <span className="badge bg-info ms-2">{emp.selectedDateCount}</span>
                                        </p>
                                        <p className="mb-0">
                                          <strong>Today:</strong>
                                          <span className="badge bg-success ms-2">{emp.todayCount}</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="col-12">
                                <div className="card shadow p-4 text-center">
                                  <p className="mb-0">No employee data found for the selected date.</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;